module.exports = __webpack_public_path__ + "img/rkd.db087975.png";